<template>
  <v-container
    fluid
    :class="this.$vuetify.theme.dark ? '' : 'grey lighten-4'"
    style="min-height: 110vh"
  >
    <v-row align="center" justify="center" class="table-cell">
      <v-col cols="12" md="5" sm="12" class="ma-3">
        <v-form v-model="valid" ref="form">
          <v-card elevation="0" class="mx-auto pa-3">
            <v-card-title
              ><h1>
                Reset admin password
                <span style="color: orange"> Quick delivery system</span>
              </h1></v-card-title
            >

            <v-text-field
              v-model="email"
              outlined
              :rules="[rules.required, rules.emailMatch]"
              prepend-icon="mdi-email"
              :label="$t('auth.login.number')"
              required
            ></v-text-field>
            <v-btn
              color="primary"
              block
              dark
              @click.prevent="restPassword"
              :disabled="clicked"
              class="mb-3"
            >
              Send
            </v-btn>
            <v-btn color="primary" outlined block to="/login"> login </v-btn>
          </v-card>
        </v-form>
        <span>{{ successMessages }}</span>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="table-cell">
      <footerTop class="ma-0 text--center" />
      <siteFooter class="ma-0" />
    </v-row>
  </v-container>
</template>
<script>
import siteFooter from "../components/siteFooter.vue";
import footerTop from "../components/footerTop.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { siteFooter, footerTop },
  name: "Reset",
  data() {
    return {
      email: "",
      clicked: false,
      valid: true,
      rules: {
        required: null,
        emailMatch: null,
      },
    };
  },
  created() {
    this.rules.required = (v) => !!v || this.$t("rules.require");
    this.rules.emailMatch = (v) =>
      !v ||
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) ||
      this.$t("rules.emailMatch");
  },
  computed: {
    ...mapGetters("alert", ["successMessages"]),
  },
  methods: {
    restPassword() {
      this.$refs.form.validate();
      if (this.valid == false) return;

      this.clicked = true;
      const payload = {
        email: this.email,
      };
      this.$store.dispatch("users/restPassword", payload);
      this.clicked = false;
    },
  },
  // metaInfo() {
  //   return {
  //     title: "Super Secret | Login",
  //   };
  // },
};
</script>

<style>
.background {
  /*background-image: url("../../assets/Path 6@2x.png");*/

  background-position: bottom; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: contain; /* Resize the background image to cover the entire container */
}
</style>
